import { RootState } from '@Store/index';
import {
  getITAccessories,
  getITReqItemsDictSelector,
  getITReqStatusesSelector,
  getSIMCapValueDictSelector,
} from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { transformDictToOptionsNum } from '@Utils/transformToOptions';
import { createSelector } from '@reduxjs/toolkit';
import { itRequisitionTypeOptionsAllowed } from './itRequisitionTypeOptionsAllowed';

const itRequisition = (state: RootState) => state.featureStores.itRequisition;

export const currentITRequisition = createSelector(
  itRequisition,
  ({ itRequisition }) => itRequisition
);

export const itReqCreateRequisitionInfo = createSelector(
  [currentITRequisition, getITReqStatusesSelector],
  (itReq, itReqStatuses) => {
    const requisitionInfo = prepareRequisitionInfo(itReq, itReqStatuses);
    return requisitionInfo;
  }
);

export const getItRequisitionTypeOptions = createSelector(
  getITReqItemsDictSelector,
  (itReqTypesDict) => {
    const itReqTypesDictFiltered = itReqTypesDict.filter(
      (itReqTypeItem) => itRequisitionTypeOptionsAllowed[itReqTypeItem.codeNum]
    );

    const itReqTypeOptions = transformDictToOptionsNum(itReqTypesDictFiltered);
    return itReqTypeOptions;
  }
);

export const getStatusLabels = createSelector(
  getITReqStatusesSelector,
  (statuses) => statuses.map((status) => status.codeDesc)
);

export const getSimCapLabels = createSelector(
  getSIMCapValueDictSelector,
  (simCapValues) => simCapValues.map((simCapValue) => simCapValue.codeDesc)
);

export const getAccessoriesLabels = createSelector(
  getITAccessories,
  (accessories) => accessories.map((accessory) => accessory.codeDesc)
);
